module.exports = __webpack_public_path__ + "static/img/search-nodata.afe5883d.png";